<span class="loading" *ngIf="loading">
    <em class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></em>
</span>

<div class="landing-container bg-color">
    <div class="logout_landingpage">
        <div>
            <div class="username">{{name}} {{role}}</div>
            <div class="username">{{userName}}</div>
        </div>
        <div>
            <img src="../../../../assets/images/header/Logout.svg" alt="logout" (click)="logout()" />
        </div>
        
    </div>
    <div class="masterLogo">
        <img src="../../assets/images/landingPage/UNILIVER-LOGO_WHITE.svg" />
    </div>
    <div class="appHeaderName">
        <div *ngFor="let card of cardItemlist" routerLink="/{{card.id}}">
            <div class="img">
                <img src="../../assets/images/landingPage/{{card.img}}.svg" />
            </div>
            <div class="cardText">{{ card.Item}}</div>
        </div>
    </div>
</div>